<div [class]="'achievement-card'">
  <div class="row no-gutters achievement">
    <div class="achievement-item col-12">
      <div class="d-flex">
        <div class="w-100">
          <div class="d-flex">
            @if (achievement.maxValue && achievement.maxValue > 0) {
              <i class="achievement-icon fas fa-play"></i>
            }
            @if (!achievement.maxValue || achievement.maxValue <= 0) {
              <i class="achievement-icon fas fa-times"></i>
            }
            <div class="w-100">
              <div>
                <span>{{ achievement.i18next_name | i18next }}</span>
                @if (achievement.maxValue && achievement.maxValue > 0) {
                  <span class="ml-1">
                    <span>
                    @if (achievement.addValue && achievement.addValue !== '') {
                      <span>({{ achievement.value | localized_currency }} / {{ achievement.maxValue | localized_currency }})</span>
                    }
                    @if (!achievement.addValue || achievement.addValue === '') {
                      <span>({{ achievement.value }} / {{ achievement.maxValue }})</span>
                      }
                    </span>
                  </span>
                }
              </div>
              @if (achievement.maxValue && achievement.maxValue > 0) {
                <div class="progress">
                  <div class="progress-bar" role="progressbar"  [ngStyle]="{ width: ((achievement.value / achievement.maxValue) * 100) + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              }
              @if (descriptionContent !== '') {
                <div class="small mt-1">
                  {{ descriptionContent }}
                </div>
              }
            </div>
            @if (helpContent !== '') {
              <i
                 class="far fa-question-circle achievement-tooltip ml-auto"
                 [pTooltip]="helpContent"
                 [tooltipEvent]="deviceService.tooltipEvent"
                 tabindex="0"></i>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
